import { render } from "./WidgetLikesAndComments.vue?vue&type=template&id=126f7a09&ts=true"
import script from "./WidgetLikesAndComments.vue?vue&type=script&lang=ts"
export * from "./WidgetLikesAndComments.vue?vue&type=script&lang=ts"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__